module.exports = "";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/dashboard/list6.jade
// module id = 304
// module chunks = 0